import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { CartProvider } from './context/CartContext'
import { AppProvider } from './context/AppContext'
import { AuthProvider } from './context/AuthContext'
import { HelmetProvider } from 'react-helmet-async'

// index.html loads the Google Fonts stylesheets as media="print" so they
// don't block rendering, then needs to flip them to media="all" once ready.
// That swap used to be an inline onload="" attribute, but our CSP's
// script-src has no 'unsafe-inline', so the browser silently blocked it.
// Doing it here instead, since this is a same-origin script CSP allows.
document.querySelectorAll('link[rel="stylesheet"][media="print"]').forEach((link) => {
  if (link.sheet) {
    link.media = 'all'
  } else {
    link.addEventListener('load', () => { link.media = 'all' }, { once: true })
  }
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <AppProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </AppProvider>
      </AuthProvider>
    </HelmetProvider>
  </StrictMode>,
)